/*==================================================
header トグルメニュー
==================================================*/
if (!navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
    $(function () {
        $('.jsSlideBtnPc').hover(function () {
            $(this).find('.slide-btn').addClass('open');
            $(this).find('.jsSlideList').stop().slideDown(500);
        }, function () {
            $(this).find('.slide-btn').removeClass('open');
            $(this).find('.jsSlideList').stop().slideUp(500);
        });
    });
} else {
    $(function () {
        $('.jsSlideList').hide();
        $('.jsSlideBtn').removeClass('open');
        $('.jsSlideBtn').off('click');
        $('.jsSlideBtn').on('touchend',function () {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).next('.jsSlideList').stop().slideUp(500);
            }else{
                $(this).addClass('open');
                $(this).next('.jsSlideList').stop().slideDown(500);
            }
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.jsSlideBtn').length) {
                    $('.jsSlideBtn').removeClass('open');
                    $('.jsSlideList').stop().slideUp(500);
            }
        });
    });
};

$(function () {
    /*==================================================
    検索 991px以下 でモーダルウィンドウfade表示/非表示
    ==================================================*/
    if ($('.modal-search').length) {
        $('.search-btn').on('click', function () {
            $('.modal-search').fadeIn(500);
            $('body').addClass('overflow');
            $('body').append('<div class="overlay-search"></div>');
        });
        $('#closeBtn').on('click', function () {
            $('body').removeClass('overflow');
            $('.overlay-search').fadeOut(300, function () {
                $('.overlay-search').remove();
            });
            $('.modal-search').fadeOut(300);
        });
        $('body').on('click', '.overlay-search', function (e) {
            $('body').removeClass('overflow');
            $('.modal-search').fadeOut(300);
            $(this).fadeOut(300, function () {
                $(this).remove();
            });
            e.stopPropagation();
        });
        $(window).on('load resize', function () {
            var wid = window.innerWidth;

            if (wid > 992) { // breakpoint設定する
                $('body').removeClass('overflow');
                $('.overlay-search').remove();
                $('.modal-search').fadeOut(0);
            }
        });
    };
});
